import React, { useMemo } from 'react';
import c from 'classnames';

import { ProfileEmpty } from '@lyearn/icons';

import ImageWithFallback from '../../Image/ImageWithFallback';
import { imageBorderStyles } from '../../styles';
import { getAvatarSizeClassName } from '../styles';
import { AvatarBaseClasses, AvatarProps } from '../types';

const DEFAULT_IMAGE_CLASS = 'w-full h-full object-cover';

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>((props, ref) => {
  const { alt, children, classes, className, disabled, name, size = 'x-large', src, style } = props;

  const mergedClasses = useMemo<AvatarBaseClasses>(
    () => ({
      image: DEFAULT_IMAGE_CLASS,
      root: c(
        'Ly-Avatar',
        disabled ? 'grayscale' : '',
        getAvatarSizeClassName(size),
        imageBorderStyles({ size: '1px' }),
        className,
        classes?.border,
      ),
    }),
    [className, classes?.border, disabled, size],
  );

  return (
    <ImageWithFallback
      ref={ref}
      alt={alt || name}
      classes={mergedClasses}
      fallback={children ?? <ProfileEmpty className={DEFAULT_IMAGE_CLASS} />}
      src={src}
      style={style}
    />
  );
});

export default React.memo(Avatar);
